import React, { useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import CustomDialog, { CustomDialogProps } from '../CustomDialog';
import { setPathBeforeLoginRequest } from 'store/slices/sessionStatus';
import { useAppSelector } from 'hooks/useAppSelector';
import { useAppDispatch } from 'hooks/useAppDispatch';

export const AuthDialog = (props: CustomDialogProps) => {
    const auth = useAppSelector((state) => state.auth);
    const help = useAppSelector((state) => state.help);
    const { showHelp } = help;
    const dispatch = useAppDispatch();
    const history = useHistory();
    const location = useLocation();
    const { tokenData } = auth;
    const { data } = tokenData ?? {};
    const { isComplete, terms } = data ?? {};

    useEffect(() => {
        if (tokenData && isComplete === false && !showHelp) {
            history.push('/finish-registration');
        }
    }, [isComplete, showHelp]);

    useEffect(() => {
        if (tokenData && terms === false && !showHelp) {
            history.push('/accept-terms');
        }
    }, [terms, showHelp]);

    useEffect(() => {
        if ((!tokenData || !tokenData.data) && !showHelp) {
            dispatch(setPathBeforeLoginRequest({ path: location.pathname }));
            history.push('/request-login');
        }
    }, [showHelp]);

    return <CustomDialog {...props} />;
};
